<template>
  <div class="container px-2">

    <product-modal v-on:close="closeProductModal"  ></product-modal>

    <modal-addItemToCart></modal-addItemToCart>

    <div class="wrapper-title-threeitems">
      <h2>{{ title }}</h2>
      <!-- <div class="form-field btn-input with-icon-ahead full" v-if="type === 'main'">
        <span><icon name="search" class="icon" scale="2"></icon></span>
        <span class="full"><input type="text" placeholder="Suche" v-model="searchQuery"></span>
        <span><button class="btn icon"><icon name="sliders" class="icon rotate-90"></icon></button></span>
      </div> -->
      <button class="btn orange sm:hidden" @click.prevent="goToProducts()" v-if="type === 'teaser'">Zur Produkt-Übersicht</button>
      <!-- <button class="btn orange sm:hidden" @click.prevent="toggleFilterModal" v-if="type === 'main'">Filter</button> -->
    </div>
    <div class="flex flex-wrap -mx-2">
      <div class="w-1/3 md:w-1/2 sm:w-full px-2 mb-4" v-for="product in products.data">
        <div class="card product-card">
          <div class="card-overlay">
            <button class="btn overlay" @click.prevent="showProduct(product)" >Zum Produkt</button>
            <button class="btn icon outline green" @click.prevent="addToCart(product)"><span><icon class="icon" name="cart-plus"></icon></span><span>In den Warenkorb</span></button>
            <!-- <button class="btn orange">Aus Favoriten entfernen</button> -->
          </div>
          <span class="cat-label">
            <icon name="sliders" class="icon rotate-90"></icon>
            <span>{{ product.category.name }}</span>
          </span>
          <img-comp :element="product" size="s" :alt="product.name"></img-comp>
          <div class="lg:hidden xl:hidden flex">
            <button :class="['btn orange inline-block w-1/2 rounded-none', 'w-full' ]"
                    @click.prevent="showProduct(product)">Zum Produkt
            </button>
            <button class="btn icon green inline-block w-1/2 rounded-none"
                    @click.prevent="addToCart(product)">
              <span><icon class="icon" name="cart-plus"></icon></span>
              <span>In den Warenkorb</span>
            </button>
          </div>
          <div class="text">
            <h3>{{ product.name }}</h3>
            <p>von <span class="vendor-name">{{ product.shop.name }}</span></p>
            <p><span class="price">{{ formatPrice(product, 'unit') }}</span><span> pro {{ getTextFromUnit(product.unit) }}</span></p>
          </div>
        </div>
      </div>
    </div>
    <div class="load-more-container md:hidden lg:hidden sm:center" v-if="type === 'teaser'">
      <button class="btn orange" @click.prevent="goToProducts()" >Zur Produkt-Übersicht</button>
    </div>
    <div class="load-more-container" v-if="type === 'main' && products.links.next && !loading">
      <button class="btn orange" @click.prevent="loadMore">Mehr laden</button>
    </div>
    <div v-if="loading" class="flex items-center">
      <div class="flex-1 text-grey-darker text-center px-4 py-4 m-4">
        <cg-loader :show="true"></cg-loader>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapActions} from 'vuex'
  import helpers from '@/mixins/helpers.js'
  import formatting from '@/mixins/formatting.js'
  import { EventBus } from '@/assets/js/event-bus.js'
  import AddItemToCart from '@/components/modals/AddItemToCart.vue'
  import ProductModal from './modals/Product'
  import CgLoader from '../components/menus/cgLoader'

  export default {
    name: 'productlist',
    components: {
      ProductModal,
      CgLoader,
      'modal-addItemToCart': AddItemToCart
    },
    props: {
      products: {
        type: Object,
        default: function () {
          return {
            data: [],
            links: {
              next: null
            }
          }
        },
        required: true
      },
      shop: {
        type: Object,
        default: function () {
          return {}
        }
      },
      type: {
        type: String,
        default: 'main'
      },
      title: {
        type: String,
        default: ''
      },
      loading: {
        type: Boolean,
        default: false
      }
    },
    mixins: [helpers, formatting],
    data () {
      return {
        searchQuery: '',
        showProductModal: false
      }
    },
    methods: {
      ...mapActions([
        'getShopProduct'
      ]),
      goToProducts () {
        if (this.shop.uid) {
          this.goTo('shopProducts', {'shop': this.shop.uid})
        } else {
          this.goTo('products')
        }
      },
      closeProductModal () {
        this.showProductModal = false
        EventBus.$emit('toggleProductModal')
      },
      showProduct (product) {
        var self = this
        var payload = {
          product: product.uid
        }
        this.$store.commit('PRODUCT_SET_SELECTED_PRODUCT', null)
        this.getShopProduct(payload)
        self.showProductModal = true
        EventBus.$emit('toggleProductModal')
      },
      toggleFilterModal () {
        EventBus.$emit('toggleFilterModal')
      },
      loadMore () {
        this.$emit('more')
      },
      addToCart (product) {
        EventBus.$emit('toggleAddItemToCartModal', product)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ProductList.vue